import React, { useEffect, useRef, useState } from "react";
import Label from "./Label";

export default function TripleConfirmButton({ onArm, actionColor = "#1F8A5B" }) {
	const [taps, setTaps] = useState(0);
	const resetRef = useRef(null);

	useEffect(() => {
		return () => clearTimeout(resetRef.current);
	}, []);

	const tap = () => {
		clearTimeout(resetRef.current);
		const next = taps + 1;
		if (next >= 3) {
			setTaps(0);
			onArm();
			return;
		}
		setTaps(next);
		resetRef.current = setTimeout(() => setTaps(0), 2400);
	};

	const labels = [160, 167, 168];

	return (
		<div className="tcb-container">
			<div className="tcb-dots">
				{[0, 1, 2].map((i) => (
					<div
						key={i}
						className="tcb-dot"
						style={{ background: i < taps ? actionColor : "#E6E6E8" }}
					/>
				))}
			</div>
			<button
				className="tcb-btn"
				style={{
					background: actionColor,
					boxShadow: "0 6px 16px " + actionColor + "55",
				}}
				onClick={tap}
			>
				<Label number={labels[taps]} />
			</button>
		</div>
	);
}
